import { call } from 'redux-saga/effects';
import * as Api from '../../../services/fbm-api';
import * as routines from './routines';
import { sagaRoutineRequest } from '../../../helpers/saga';

export const fetchVisitColumns = () =>
  sagaRoutineRequest(routines.fetchVisitColumns, {
    request: () => call(Api.fetchVisitColumns)
  });

export const fetchVisitOrderByTrackingMethods = ({
  payload: { visitId, trackingMethodIds }
}) =>
  sagaRoutineRequest(routines.fetchVisitOrderByTrackingMethods, {
    request: () =>
      call(Api.fetchVisitOrderByTrackingMethods, { visitId, trackingMethodIds })
  });

export const fetchVisitConfigs = () =>
  sagaRoutineRequest(routines.fetchVisitConfigs, {
    request: () => call(Api.fetchVisitConfigs, {})
  });
